import { Component, OnInit, ViewChild } from '@angular/core';
import { SyncProgressService } from '../../../../../services/sync-progress.service';
import { Paginator } from 'primeng/paginator';
import moment from 'moment';

@Component({
  selector: 'app-sync-progress',
  templateUrl: './sync-progress.component.html',
  styleUrls: ['./sync-progress.component.scss'],
})
export class SyncProgressComponent implements OnInit {
  public allData: any[] = [];
  public filteredData: any[] = [];
  public pagedData: any[] = [];
  public columns: string[] = [];
  public totalRecords = 0;
  public page = 0;
  public limit = 25;
  public loading = false;
  public search: string = '';

  @ViewChild('paginator') paginator: Paginator;

  constructor(private syncProgressService: SyncProgressService) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.syncProgressService.getSyncProgress().subscribe(
      (result: any[]) => {
        this.allData = result || [];
        this.totalRecords = this.allData.length;
        if (this.allData.length > 0) {
          this.columns = Object.keys(this.allData[0]);
        }
        this.applyFilter();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error('Error fetching sync progress', err);
      },
    );
  }

  applyFilter() {
    const term = this.search.trim().toLowerCase();
    if (!term) {
      this.filteredData = [...this.allData];
    } else {
      this.filteredData = this.allData.filter((row) =>
        this.columns.some((col) => {
          const val = this.formatCellValue(row[col]).toLowerCase();
          return val.includes(term);
        }),
      );
  }
    this.totalRecords = this.filteredData.length;
    this.page = 0;
    if (this.paginator) {
      this.paginator.changePage(0);
    }
    this.updatePagedData();
  }

  clearFilter() {
    this.search = '';
    this.applyFilter();
  }

  paginate(event: any) {
    this.page = event.page;
    this.limit = event.rows;
    this.updatePagedData();
  }

  private updatePagedData() {
    const start = this.page * this.limit;
    this.pagedData = this.filteredData.slice(start, start + this.limit);
  }

  formatColumnHeader(key: string): string {
    return key
      .replace(/_/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .trim();
  }

  formatCellValue(value: any): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    }
    return String(value);
  }
}
